// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExtensionCard_mainCard__BvPJl {
  width: 100%;
  margin-bottom: 5px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc((100% - 40px) / 5);
  max-width: calc((100% - 40px) / 5);
}

.ExtensionCard_card__-dYHy {
  position: relative;
  display: flex;
  width: 100%;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: 4px;
  border: 2px solid transparent;
}

@media only screen and (max-width: 800px) {
  .ExtensionCard_mainCard__BvPJl {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc((100% - 30px) / 3);
    max-width: calc((100% - 40px) / 3);
  }
}
@media only screen and (max-width: 1000px) {
  .ExtensionCard_mainCard__BvPJl {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc((100% - 30px) / 4);
    max-width: calc((100% - 30px) / 4);
  }
}
@media only screen and (max-width: 1200px) {
  .ExtensionCard_mainCard__BvPJl {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc((100% - 30px) / 5);
  }
}
@media only screen and (max-width: 700px) {
  .ExtensionCard_mainCard__BvPJl {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc((100% - 30px) / 2);
    max-width: calc((100% - 15px) / 2) !important;
  }
}
@media only screen and (max-width: 600px) {
  .ExtensionCard_mainCard__BvPJl {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc((100% - 30px) / 1);
    max-width: calc((100% - 5px) / 1) !important;
  }
}
.ExtensionCard_green__FYiFV {
  background-color: #daf7ba;
}

.ExtensionCard_green__FYiFV:hover {
  border: 2px solid #6fc316;
}

.ExtensionCard_orange__7xbx2 {
  background-color: #ffe0b2;
}

.ExtensionCard_orange__7xbx2:hover {
  border: 2px solid #ffae35;
}

.ExtensionCard_empity__CCUVW {
  background-color: #fff;
  border: 2px solid #d3dce0;
}

.ExtensionCard_gray__44Ij1 {
  background-color: #e9eef0;
}

.ExtensionCard_gray__44Ij1:hover {
  border: 2px solid #96a5ab;
}

.ExtensionCard_header__GWJnc {
  display: flex;
  padding: 1px 8px 1px 4px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
}

.ExtensionCard_dotIndication__Ryiwr {
  border-radius: 50%;
  min-width: 9px !important;
  min-height: 9px !important;
  background-color: #6fc316;
  margin-right: 5px;
}

.ExtensionCard_label__6Lo-Q {
  color: #2d3841;
  font-family: Lato, sans-serif;
  font-size: 0.8em;
  font-style: normal;
  margin-right: 3px;
}
.ExtensionCard_label_name__7FNi7 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  max-width: 100%;
}

.ExtensionCard_svgIcon__hkMuJ svg {
  display: block;
  width: 13px;
  height: 13px;
  margin: auto;
  cursor: pointer;
}

.ExtensionCard_svgIcon_active__C7wLu path {
  fill: rgb(202, 202, 202);
}

.ExtensionCard_callBtn__uhJCc {
  display: flex;
  margin: 0 6px;
}
.ExtensionCard_callBtn__uhJCc button {
  height: auto;
  width: auto;
  padding: 0;
}
.ExtensionCard_callBtn__uhJCc svg {
  width: 14px !important;
  height: 14px !important;
}

.ExtensionCard_callHangUpBtn__sCJph {
  display: flex;
  margin-left: 5px;
}
.ExtensionCard_callHangUpBtn__sCJph button {
  height: auto;
  width: auto;
  padding: 0;
}
.ExtensionCard_callHangUpBtn__sCJph svg {
  stroke: var(--status-danger);
  fill: var(--status-danger);
  border: 0;
  transform: scale(1.3);
  margin-right: 5px;
  width: 14px !important;
  height: 14px !important;
}
.ExtensionCard_callHangUpBtn__sCJph svg path {
  stroke-width: 0;
}

.ExtensionCard_callTransfer__WDr8X {
  display: flex;
}
.ExtensionCard_callTransfer__WDr8X button {
  height: auto;
  width: auto;
  padding: 0;
}
.ExtensionCard_callTransfer__WDr8X svg {
  stroke: #6c7a8b;
  fill: #6c7a8b;
  width: 14px !important;
  width: 14px !important;
  margin-right: 6px;
  border: 0;
}
.ExtensionCard_callTransfer__WDr8X svg path {
  stroke-width: 0;
}

.ExtensionCard_transferCard__\\+4cpB {
  position: absolute;
  bottom: -44px;
  left: 0;
}

.ExtensionCard_isCallTransferHover__-dA\\+Q svg {
  stroke: var(--primary-default);
  fill: var(--primary-default);
}

.ExtensionCard_callBtn__uhJCc svg {
  display: block;
  width: 13px;
  height: 13px;
  margin: auto;
  cursor: pointer;
}

.ExtensionCard_voicemail__G7SQk {
  margin-left: auto;
  width: 16px;
  height: 16px;
}

.ExtensionCard_svgCallLineStatusReady__hOS5u {
  min-height: 12px;
  max-height: 12px;
  min-width: 12px;
  max-width: 12px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
}

.ExtensionCard_lineIcon__e5G8u {
  width: 12px;
  height: 12px;
  opacity: 0.8;
}
.ExtensionCard_lineIcon__e5G8u path {
  fill: var(--icon-primary);
}

.ExtensionCard_labelLeft__bNBCK {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  flex: 1 0;
  overflow: hidden;
  color: var(--text-secondary);
  text-overflow: ellipsis;
}

.ExtensionCard_bgW__cqXBv {
  background-color: #fff;
}

.ExtensionCard_bgR__WMGjn {
  background-color: var(--status-danger);
}

.ExtensionCard_bgG__lquHR {
  background-color: var(--status-disabled);
}

.ExtensionCard_lines__N4pFH {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
  align-self: stretch;
}

.ExtensionCard_line__m4rQB {
  display: flex;
  min-height: 20px;
  padding: 2px 8px;
  align-items: center;
  gap: 5px;
  align-self: stretch;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 3px;
}

.ExtensionCard_statusBlock__ybZgB {
  display: flex;
  align-items: center;
  margin-left: 3px;
}
.ExtensionCard_statusBlock__ybZgB svg {
  width: 12px !important;
  width: 12px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Sidecar/ExtensionCard/ExtensionCard.module.scss"],"names":[],"mappings":"AA8DA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EAAA,cAAA;EAAA,mCAAA;EACA,kCAAA;AA7DD;;AA+DA;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;AA5DD;;AA+DA;EACC;IACC,YAAA;IAAA,cAAA;IAAA,mCAAA;IACA,kCAAA;EA5DA;AACF;AA8DA;EACC;IACC,YAAA;IAAA,cAAA;IAAA,mCAAA;IACA,kCAAA;EA5DA;AACF;AA8DA;EACC;IACC,YAAA;IAAA,cAAA;IAAA,mCAAA;EA5DA;AACF;AA+DA;EACC;IACC,YAAA;IAAA,cAAA;IAAA,mCAAA;IACA,6CAAA;EA7DA;AACF;AAgEA;EACC;IACC,YAAA;IAAA,cAAA;IAAA,mCAAA;IACA,4CAAA;EA9DA;AACF;AAiEA;EACC,yBAAA;AA/DD;;AAiEA;EACC,yBAAA;AA9DD;;AAgEA;EACC,yBAAA;AA7DD;;AA+DA;EACC,yBAAA;AA5DD;;AA8DA;EACC,sBAAA;EACA,yBAAA;AA3DD;;AA6DA;EACC,yBAAA;AA1DD;;AA4DA;EACC,yBAAA;AAzDD;;AA2DA;EACC,aAAA;EACA,wBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAxDD;;AA0DA;EAEC,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,iBAAA;AAxDD;;AA2DA;EACC,cAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AAxDD;AA0DC;EACC,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAxDF;;AA4DA;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAzDD;;AA6DC;EACC,wBAAA;AA1DF;;AA8DA;EACC,aAAA;EACA,aAAA;AA3DD;AA6DC;EACC,YAAA;EACA,WAAA;EACA,UAAA;AA3DF;AA8DC;EACC,sBAAA;EACA,uBAAA;AA5DF;;AA+DA;EACC,aAAA;EACA,gBAAA;AA5DD;AA6DC;EACC,YAAA;EACA,WAAA;EACA,UAAA;AA3DF;AA6DC;EACC,4BAAA;EACA,0BAAA;EACA,SAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;AA3DF;AA6DE;EACC,eAAA;AA3DH;;AA+DA;EACC,aAAA;AA5DD;AA6DC;EACC,YAAA;EACA,WAAA;EACA,UAAA;AA3DF;AA6DC;EACC,eAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,iBAAA;EACA,SAAA;AA3DF;AA4DE;EACC,eAAA;AA1DH;;AA8DA;EACC,kBAAA;EACA,aAAA;EACA,OAAA;AA3DD;;AA8DC;EACC,8BAAA;EACA,4BAAA;AA3DF;;AA+DA;EACC,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AA5DD;;AA8DA;EACC,iBAAA;EACA,WAAA;EACA,YAAA;AA3DD;;AA6DA;EACC,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,2BAAA;EACA,4BAAA;EACA,wBAAA;AA1DD;;AA6DA;EACC,WAAA;EACA,YAAA;EACA,YAAA;AA1DD;AA2DC;EACC,yBAAA;AAzDF;;AA4DA;EACC,oBAAA;EACA,4BAAA;EACA,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;AAzDD;;AA2DA;EACC,sBAAA;AAxDD;;AA0DA;EACC,sCAAA;AAvDD;;AAyDA;EACC,wCAAA;AAtDD;;AAwDA;EACC,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;AArDD;;AAuDA;EACC,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EAEA,oCAAA;EACA,kBAAA;AArDD;;AAuDA;EACC,aAAA;EACA,mBAAA;EACA,gBAAA;AApDD;AAsDC;EACC,sBAAA;EACA,sBAAA;AApDF","sourcesContent":["// .card {\n// \twidth: 100%;\n// \theight: 44px;\n\n// \tborder-radius: 8px;\n// \tborder: 1px solid var(--border-tertiary, #e3eaf2);\n\n// \tmargin-bottom: 10px;\n\n// \tpadding: 2px;\n// }\n\n// .innerCard {\n// \twidth: 100%;\n// \theight: 100%;\n// \t// border-radius: 8px;\n// \tdisplay: flex;\n// \tjustify-content: space-between;\n// \talign-items: center;\n\n// \t// border-left: 5px solid #75c322;\n\n// \th1 {\n// \t\tdisplay: flex;\n// \t\talign-items: center;\n// \t\tgap: 5px;\n\n// \t\tcolor: var(--text-primary, #1f2023);\n\n// \t\t/* Body/Regular */\n// \t\tfont-family: Poppins;\n// \t\tfont-size: 15px;\n// \t\tfont-style: normal;\n// \t\tfont-weight: 400;\n// \t\tline-height: 20px; /* 133.333% */\n// \t\tletter-spacing: -0.5px;\n// \t}\n\n// \tp {\n// \t\tcolor: var(--text-secondary, #5c6168);\n// \t\ttext-align: right;\n\n// \t\t/* Body/Regular */\n// \t\tfont-family: Poppins;\n// \t\tfont-size: 15px;\n// \t\tfont-style: normal;\n// \t\tfont-weight: 400;\n// \t\tline-height: 20px; /* 133.333% */\n// \t\tletter-spacing: -0.5px;\n\n// \t\tpadding-right: 5px;\n// \t\tdisplay: table;\n// \t\ttext-align: center;\n// \t\tspan{\n// \t\t\tdisplay: table-cell;\n// \t\t\tvertical-align: middle;\n// \t\t\tpadding-right: 3px;\n// \t\t}\n// \t}\n// }\n//Version 2\n\n.mainCard {\n\twidth: 100%;\n\tmargin-bottom: 5px;\n\tflex: 1 1 calc((100% - 40px) / 5);\n\tmax-width: calc((100% - 40px) / 5);\n}\n.card {\n\tposition: relative;\n\tdisplay: flex;\n\twidth: 100%;\n\tpadding: 4px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 4px;\n\tborder-radius: 4px;\n\tborder: 2px solid transparent;\n}\n\n@media only screen and (max-width: 800px) {\n\t.mainCard {\n\t\tflex: 1 1 calc((100% - 30px) / 3);\n\t\tmax-width: calc((100% - 40px) / 3);\n\t}\n}\n@media only screen and (max-width: 1000px) {\n\t.mainCard {\n\t\tflex: 1 1 calc((100% - 30px) / 4);\n\t\tmax-width: calc((100% - 30px) / 4);\n\t}\n}\n@media only screen and (max-width: 1200px) {\n\t.mainCard {\n\t\tflex: 1 1 calc((100% - 30px) / 5);\n\t}\n}\n\n@media only screen and (max-width: 700px) {\n\t.mainCard {\n\t\tflex: 1 1 calc((100% - 30px) / 2) !important;\n\t\tmax-width: calc((100% - 15px) / 2) !important;\n\t}\n}\n\n@media only screen and (max-width: 600px) {\n\t.mainCard {\n\t\tflex: 1 1 calc((100% - 30px) / 1) !important;\n\t\tmax-width: calc((100% - 5px) / 1) !important;\n\t}\n}\n\n.green {\n\tbackground-color: #daf7ba;\n}\n.green:hover {\n\tborder: 2px solid #6fc316;\n}\n.orange {\n\tbackground-color: #ffe0b2;\n}\n.orange:hover {\n\tborder: 2px solid #ffae35;\n}\n.empity {\n\tbackground-color: #fff;\n\tborder: 2px solid #d3dce0;\n}\n.gray {\n\tbackground-color: #e9eef0;\n}\n.gray:hover {\n\tborder: 2px solid #96a5ab;\n}\n.header {\n\tdisplay: flex;\n\tpadding: 1px 8px 1px 4px;\n\talign-items: center;\n\tgap: 4px;\n\talign-self: stretch;\n}\n.dotIndication {\n\t// border: 1px solid var(--border-tertiary);\n\tborder-radius: 50%;\n\tmin-width: 9px !important;\n\tmin-height: 9px !important;\n\tbackground-color: #6fc316;\n\tmargin-right: 5px;\n}\n\n.label {\n\tcolor: #2d3841;\n\tfont-family: Lato, sans-serif;\n\tfont-size: 0.8em;\n\tfont-style: normal;\n\tmargin-right: 3px;\n\n\t&_name {\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\twhite-space: nowrap;\n\t\twidth: 100%;\n\t\tmax-width: 100%;\n\t}\n}\n\n.svgIcon svg {\n\tdisplay: block;\n\twidth: 13px;\n\theight: 13px;\n\tmargin: auto;\n\tcursor: pointer;\n}\n\n.svgIcon_active {\n\tpath {\n\t\tfill: rgb(202, 202, 202);\n\t}\n}\n\n.callBtn {\n\tdisplay: flex;\n\tmargin: 0 6px;\n\n\tbutton {\n\t\theight: auto;\n\t\twidth: auto;\n\t\tpadding: 0;\n\t}\n\n\tsvg {\n\t\twidth: 14px !important;\n\t\theight: 14px !important;\n\t}\n}\n.callHangUpBtn {\n\tdisplay: flex;\n\tmargin-left: 5px;\n\tbutton {\n\t\theight: auto;\n\t\twidth: auto;\n\t\tpadding: 0;\n\t}\n\tsvg {\n\t\tstroke: var(--status-danger);\n\t\tfill: var(--status-danger);\n\t\tborder: 0;\n\t\ttransform: scale(1.3);\n\t\tmargin-right: 5px;\n\t\twidth: 14px !important;\n\t\theight: 14px !important;\n\n\t\tpath {\n\t\t\tstroke-width: 0;\n\t\t}\n\t}\n}\n.callTransfer {\n\tdisplay: flex;\n\tbutton {\n\t\theight: auto;\n\t\twidth: auto;\n\t\tpadding: 0;\n\t}\n\tsvg {\n\t\tstroke: #6c7a8b;\n\t\tfill: #6c7a8b;\n\t\twidth: 14px !important;\n\t\twidth: 14px !important;\n\t\tmargin-right: 6px;\n\t\tborder: 0;\n\t\tpath {\n\t\t\tstroke-width: 0;\n\t\t}\n\t}\n}\n.transferCard {\n\tposition: absolute;\n\tbottom: -44px;\n\tleft: 0;\n}\n.isCallTransferHover {\n\tsvg {\n\t\tstroke: var(--primary-default);\n\t\tfill: var(--primary-default);\n\t}\n}\n\n.callBtn svg {\n\tdisplay: block;\n\twidth: 13px;\n\theight: 13px;\n\tmargin: auto;\n\tcursor: pointer;\n}\n.voicemail {\n\tmargin-left: auto;\n\twidth: 16px;\n\theight: 16px;\n}\n.svgCallLineStatusReady {\n\tmin-height: 12px;\n\tmax-height: 12px;\n\tmin-width: 12px;\n\tmax-width: 12px;\n\tbackground-position: center;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\t// background-image: url(/assets/icons/call-line-status/caller_ready.svg);\n}\n.lineIcon {\n\twidth: 12px;\n\theight: 12px;\n\topacity: 0.8;\n\tpath {\n\t\tfill: var(--icon-primary);\n\t}\n}\n.labelLeft {\n\tdisplay: -webkit-box;\n\t-webkit-box-orient: vertical;\n\t-webkit-line-clamp: 1;\n\tflex: 1 0 0;\n\toverflow: hidden;\n\tcolor: var(--text-secondary);\n\ttext-overflow: ellipsis;\n}\n.bgW {\n\tbackground-color: #fff;\n}\n.bgR {\n\tbackground-color: var(--status-danger);\n}\n.bgG {\n\tbackground-color: var(--status-disabled);\n}\n.lines {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 1px;\n\talign-self: stretch;\n}\n.line {\n\tdisplay: flex;\n\tmin-height: 20px;\n\tpadding: 2px 8px;\n\talign-items: center;\n\tgap: 5px;\n\talign-self: stretch;\n\t// background: rgba(255, 255, 255, 0.5);\n\tbackground: rgba(255, 255, 255, 0.5);\n\tborder-radius: 3px;\n}\n.statusBlock {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-left: 3px;\n\n\tsvg {\n\t\twidth: 12px !important;\n\t\twidth: 12px !important;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainCard": `ExtensionCard_mainCard__BvPJl`,
	"card": `ExtensionCard_card__-dYHy`,
	"green": `ExtensionCard_green__FYiFV`,
	"orange": `ExtensionCard_orange__7xbx2`,
	"empity": `ExtensionCard_empity__CCUVW`,
	"gray": `ExtensionCard_gray__44Ij1`,
	"header": `ExtensionCard_header__GWJnc`,
	"dotIndication": `ExtensionCard_dotIndication__Ryiwr`,
	"label": `ExtensionCard_label__6Lo-Q`,
	"label_name": `ExtensionCard_label_name__7FNi7`,
	"svgIcon": `ExtensionCard_svgIcon__hkMuJ`,
	"svgIcon_active": `ExtensionCard_svgIcon_active__C7wLu`,
	"callBtn": `ExtensionCard_callBtn__uhJCc`,
	"callHangUpBtn": `ExtensionCard_callHangUpBtn__sCJph`,
	"callTransfer": `ExtensionCard_callTransfer__WDr8X`,
	"transferCard": `ExtensionCard_transferCard__+4cpB`,
	"isCallTransferHover": `ExtensionCard_isCallTransferHover__-dA+Q`,
	"voicemail": `ExtensionCard_voicemail__G7SQk`,
	"svgCallLineStatusReady": `ExtensionCard_svgCallLineStatusReady__hOS5u`,
	"lineIcon": `ExtensionCard_lineIcon__e5G8u`,
	"labelLeft": `ExtensionCard_labelLeft__bNBCK`,
	"bgW": `ExtensionCard_bgW__cqXBv`,
	"bgR": `ExtensionCard_bgR__WMGjn`,
	"bgG": `ExtensionCard_bgG__lquHR`,
	"lines": `ExtensionCard_lines__N4pFH`,
	"line": `ExtensionCard_line__m4rQB`,
	"statusBlock": `ExtensionCard_statusBlock__ybZgB`
};
export default ___CSS_LOADER_EXPORT___;
